export const ADMIN_ROUTE_NAMES = {
  ADMIN_ROOT: 'admin-root',
  ADMIN_EXPORT_LANDING_ROUTE_PREFIX: 'admin-export-landing-page-',
  ADMIN_EXPORT_CREATE_ROUTE_PREFIX: 'admin-export-create-',
  ADMIN_EXPORT_EDIT_ROUTE_PREFIX: 'admin-export-edit-',
  ADMIN_LIST_LANDING_ROUTE_PREFIX: 'admin-list-landing-page-',
  ADMIN_LIST_CREATE_ROUTE_PREFIX: 'admin-list-create-',
  ADMIN_LIST_EDIT_ROUTE_PREFIX: 'admin-list-edit-',
} as const

export const ADMIN_ROUTE_PATHS = {
  ADMIN_AUTH_SETTINGS_ROUTE: '/assist/admin/v2/authenticationSettings',
  ADMIN_AI_SUMMARIZE: '/assist/admin/ai/summarize',
  AUTOMATIC_RESOLUTION_NOTES: '/assist/admin/ai/automatic-resolution-notes',
} as const
